<template>
  <Modal
    v-model="_value"
    width="500"
    title="锐明查询参数"
    @on-visible-change="visibleChange"
    ok-text="查询"
    @on-ok="onSendDriverCardParams"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="queryParametersModal" :label-width="90">
      <FormItem prop="driverName" label="密码">
        <Button type="primary" @click="possworsOne" style="margin-right: 5px;">密码1</Button>
        <Button type="primary" @click="posswordTwo">密码2</Button>
        <Input v-model="queryParametersModal.possword" type="password" password placeholder="请输入密码">
        </Input>
      </FormItem>
<!--      <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>-->
<!--      <Button type="primary" @click="onSendDriverCardParams">发送</Button>-->
    </Form>
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

import MaintainOrderAddMaintainDeviceRecordModal from '@/view/om/components/maintain-order-add-maintain-device-record-modal'

export default {
  name: 'rmqueryparametersmodal',
  components: {

  },
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      queryParametersModal: {
        id:null,
        possword: 'admin',
      },

    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    visibleChange (val) {
      if (val) {
        this.queryParametersModal.id = this._initValue
        this.possworsOne()
      }
    },
    onCleanDriverCardParams () {
      this.queryParametersModal.possword = 'admin'
    },
    onSendDriverCardParams () {
      console.log('99admin,' + this.queryParametersModal.possword + ',QHTA!')
      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this._initValue, content: '99admin,' + this.queryParametersModal.possword + ',QHTA!', urgent: false }
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    possworsOne(){
      this.queryParametersModal.possword = 'admin'
    },
    posswordTwo(){
      this.queryParametersModal.possword = 'JC336699'
    },
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
